<div class="certification-box">
  <h6 class="column-header">Certification Decision</h6>
  <div class="certification-decision-note">Please verify all information before certifying this student record.</div>
  <div class="certification-cards">
    <button
      type="button"
      class="cert-card"
      [class.selected]="certifyChoice === 'yes'"
      (click)="onCertifyChoiceSelect('yes')"
      [disabled]="isNotAttending || isCertificationRestricted">
      <div class="cert-card-label">Yes, this student is enrolled at my school</div>
      <div class="cert-card-desc">
        I certify this student is enrolled at my school and the cost information is correct.
      </div>
    </button>
    <button
      type="button"
      class="cert-card"
      [class.selected]="certifyChoice === 'no'"
      (click)="onCertifyChoiceSelect('no')"
      [disabled]="isCertificationRestricted">
      <div class="cert-card-label">No, this student is not enrolled at my school</div>
    </button>
  </div>

  <div class="cert-action-row">
    <button
      class="close-button secondary_materials_button small_button"
      disableRipple="true"
      type="button"
      mat-stroked-button
      (click)="onCancel()">
      Cancel
    </button>
    <span [matTooltip]="restrictionTooltipMessage" [matTooltipDisabled]="!isCertificationRestricted">
      <button
        class="primary_materials_button small_button"
        disableRipple="true"
        type="button"
        mat-stroked-button
        [disabled]="isCertifyDisabled"
        (click)="onCertify()">
        @if (certifying) {
          <mat-spinner diameter="16" style="display: inline-block; margin-right: 8px"></mat-spinner>
        }
        {{ certifying ? 'Certifying...' : (certifyChoice === 'no' ? 'Submit' : 'Certify') }}
      </button>
    </span>
  </div>
</div>
